/* eslint-disable no-undef */
import EnvironmentConfiguration from "./types/EnvironmentConfiguration";
import TelemetryClient from "./Telemetry/compositions/TelemetryClient";

const { googleTagsManager } = EnvironmentConfiguration;

if (googleTagsManager.enabled) {
  try {
    if (!googleTagsManager.containerId) {
      console.warn("[GTM] VITE_GTM_ENABLED is true but VITE_GTM_CONTAINER_ID is not set. GTM will not be initialized.");
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

      const params = new URLSearchParams({ id: googleTagsManager.containerId });
      if (googleTagsManager.auth) params.set("gtm_auth", googleTagsManager.auth);
      if (googleTagsManager.preview) params.set("gtm_preview", googleTagsManager.preview);
      if (googleTagsManager.cookiesWin) params.set("gtm_cookies_win", googleTagsManager.cookiesWin);

      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?${params.toString()}`;

      const firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode!.insertBefore(script, firstScript);
    }
  } catch (error) {
    TelemetryClient.traceException(error as Error);
  }
}
